import { render, staticRenderFns } from "./MobileFixedFooter.vue?vue&type=template&id=0122f2a9&scoped=true"
import script from "./MobileFixedFooter.vue?vue&type=script&lang=js"
export * from "./MobileFixedFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileFixedFooter.vue?vue&type=style&index=0&id=0122f2a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122f2a9",
  null
  
)

export default component.exports